import { useLayoutEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';

export const useSvgTruncatedText = ({
  text,
  maxWidthPx,
}: {
  text: string;
  maxWidthPx?: number;
}) => {
  const textRef = useRef<SVGTextElement | null>(null);
  const [displayText, setDisplayText] = useState(text);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el || !maxWidthPx) {
      return;
    }

    if (el.getComputedTextLength() <= maxWidthPx) {
      return;
    }

    let chars = 0;

    for (let i = 1; i <= text.length; i++) {
      if (el.getSubStringLength(0, i) > maxWidthPx) {
        break;
      }
      chars = i;
    }

    const truncated =
      chars < text.length ? `${text.slice(0, Math.max(0, chars - 1))}…` : text;
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setDisplayText((prev) => (prev === truncated ? prev : truncated));
  }, [text, maxWidthPx]);

  return { ref: textRef, displayText };
};
